class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);


    if($('.page-template-cart').length){
        $("#main-cart-items .cart-items .cart-item").each(function(){
          //alert($(this).text());
            let get_cart_item = $(this);
            if($(this).hasClass('hide_bundle_item')){
                let get_bundle_variant_ids = get_cart_item.attr("data-bundle-kit-ids");
                //alert(get_bundle_variant_ids);
                //get_cart_item.find("cart-remove-button button").trigger("click");
                const myArrayBundle = get_bundle_variant_ids.split(",");                
                let ava_bundle_item_counter = 0;
                $.each(myArrayBundle, function(key,val) {      
                    var isLastElement = key == myArrayBundle.length -1;            
                    //alert("key="+key+" value = "+val);         
                    let bundle_kit_item_variant_class = ".cart_item_variant_"+val;
                    if($(bundle_kit_item_variant_class).length){
                        //alert("found");
                        ava_bundle_item_counter = ava_bundle_item_counter + 1;
                    }
                    if (isLastElement) {
                        //if(ava_bundle_item_counter == 
                        //alert(ava_bundle_item_counter+" == "+myArrayBundle.length);
                        if(ava_bundle_item_counter == myArrayBundle.length){
                          //alert(ava_bundle_item_counter+" == "+myArrayBundle.length);
                        }else{
                          jQuery.post(window.Shopify.routes.root + 'cart/clear.js');
                          get_cart_item.find("cart-remove-button .button").trigger("click");
                        }
                        
                    }            
                });             
            }
        });          
    }
    
    $(".drawer__cart-items-wrapper .cart-items .cart-item").each(function(){
      //alert($(this).text());
        let get_cart_item = $(this);
        if($(this).hasClass('hide_bundle_item')){
            let get_bundle_variant_ids = get_cart_item.attr("data-bundle-kit-ids");
            //alert(get_bundle_variant_ids);
            //get_cart_item.find("cart-remove-button button").trigger("click");
            const myArrayBundle = get_bundle_variant_ids.split(",");                
            let ava_bundle_item_counter = 0;
            $.each(myArrayBundle, function(key,val) {      
                var isLastElement = key == myArrayBundle.length -1;            
                //alert("key="+key+" value = "+val);         
                let bundle_kit_item_variant_class = ".item_variant_"+val;
                if($(bundle_kit_item_variant_class).length){
                    //alert("found");
                    ava_bundle_item_counter = ava_bundle_item_counter + 1;
                }
                if (isLastElement) {
                    //if(ava_bundle_item_counter == 
                    if(ava_bundle_item_counter == myArrayBundle.length){
                      //alert(ava_bundle_item_counter+" == "+myArrayBundle.length);
                    }else{
                      get_cart_item.find("cart-remove-button button").trigger("click");
                    }
                    
                }            
            });             
        }
    });    
    
    
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
};

/* On Cart Page Windows on Load */
    if($('.page-template-cart').length){
        $("#main-cart-items .cart-items .cart-item").each(function(){          
            let get_cart_item = $(this);
            if($(this).hasClass('hide_bundle_item')){
                let get_bundle_variant_ids = get_cart_item.attr("data-bundle-kit-ids");
                //alert(get_bundle_variant_ids);
                //get_cart_item.find(".quantity__input").val(1);
                //let get_qty_id = get_cart_item.find(".quantity__input").attr("id")
                //let element = document.getElementById(get_qty_id);
                //element.dispatchEvent(new Event('change', { 'bubbles': true }));              
                //get_cart_item.find("cart-remove-button button").trigger("click");
                const myArrayBundle = get_bundle_variant_ids.split(",");                
                let ava_bundle_item_counter = 0;
                $.each(myArrayBundle, function(key,val) {      
                    var isLastElement = key == myArrayBundle.length -1;            
                    //alert("key="+key+" value = "+val);         
                    let bundle_kit_item_variant_class = ".cart_item_variant_"+val;
                    if($(bundle_kit_item_variant_class).length){
                        //alert("found");
                        ava_bundle_item_counter = ava_bundle_item_counter + 1;
                    }
                    if (isLastElement) {
                        //if(ava_bundle_item_counter == 
                        if(ava_bundle_item_counter == myArrayBundle.length){
                          //alert(ava_bundle_item_counter+" == "+myArrayBundle.length);
                        }else{
                          jQuery.post(window.Shopify.routes.root + 'cart/clear.js');
                          get_cart_item.find("cart-remove-button .button").trigger("click");
                        }
                        
                    }            
                });             
            }
        });          
    }


function countdownByClass(className, minutes, seconds) {
    var elements = document.getElementsByClassName(className);
    if (elements.length === 0) {
        console.error("Element with class '" + className + "' not found.");
        return;
    }

    var endTime, hours, mins, msLeft, time;

    function twoDigits(n) {
        return (n <= 9 ? "0" + n : n);
    }

    function updateTimer() {
        msLeft = endTime - (+new Date);
        if (msLeft < 1000) {
            for (var i = 0; i < elements.length; i++) {
                elements[i].innerHTML = "Time is up!";
            }
        } else {
            time = new Date(msLeft);
            hours = time.getUTCHours();
            mins = time.getUTCMinutes();
            var timeString = (hours ? hours + ':' + twoDigits(mins) : mins) + ':' + twoDigits(time.getUTCSeconds());

            for (var i = 0; i < elements.length; i++) {
                elements[i].innerHTML = timeString;
            }

            setTimeout(updateTimer, time.getUTCMilliseconds() + 500);
        }
    }

    endTime = (+new Date) + 1000 * (60 * minutes + seconds) + 500;
    updateTimer();
}

countdownByClass("ten-countdown", 12, 0);

 document.querySelectorAll('.myProgressBar').forEach(function(progressBar) {
    const completedValue = progressBar.value;
    const maxValue = progressBar.max;
    const completedPercentage = (completedValue / maxValue) * 100;

    // Display completed percentage
    const completionPercentageSpan = progressBar.nextElementSibling; // Select the next sibling, assuming it's the span
    completionPercentageSpan.textContent = `${completedPercentage.toFixed(2)}% Completed`;
  });